import clientFollowUp from './clientFollowUp'
export default clientFollowUp
